export const pay_zh = {
    pay:{     
        Payment:"支付详情",
        AccountUpgrade:"账户升级",
        AmountPaid:"支付金额",
        currency:"支付币种",
        network:"支付网络",
        address:"支付地址",
        PaymentID:"支付txid",
        SubmitPayment:"提交支付",
        Confirmation:"确认支付信息",
        AccountLevel:"账户等级",
        ConfirmationPayment:"确认支付",
        cancel:"取 消",
        L2users:"今日L2用户数",
        L3users:"今日L3用户数",
        L4users:"今日L4用户数",
        AmountReceived:"今日收款金额",
        addL2:"今日新增L2用户数",
        addL3:"今日新增L3用户数",
        addL4:"今日新增L4用户数",
        TotalCollection:"总收款金额",
        TotalCollectionL2:"L2用户总收款金额",
        TotalCollectionL3:"L3用户总收款金额",
        TotalCollectionL4:"L4用户总收款金额",
        chart:"每日历史图表",
        beConfirmedTable:"待确认支付列表",
        confirmedTable:"已确认支付列表",
        edit:"编辑历史",
        number:"编号",
        date:"日期",
        user:"用户",
        CausePayment:"支付原由",
        CollectionAddress:"收款地址",
        PaymentStatus:"支付状态",
        edit1:"编辑",
        EditingReason:"编辑原由",
        submit:"提交",
        ServiceStatus:"服务生效状态",
        OriginalPayment:"原支付状态",
        presentPaymentStatus:"当前支付状态",
        EditUser:"编辑用户",
        PaymentHistory:"支付历史",
        PurchaseService:"购买服务",
        userPlan:"用户计划",
        AccountAuthority:"账户权限等级详情",
        Refers:"指标标识",
        WhetherPay:"是否需要付费",
        authority:"权限",
        granularity:"数据颗粒度",
        expense:"费用",
        AnonymousUser:"匿名用户",
        technicalL1:"L1技术指标",
        technicalL2:"L2技术指标",
        technicalL3:"L3技术指标",
        technicalL4:"L4技术指标",
        RegisteredUser:"注册用户",
        monthlyPay:"月度付费用户",
        greatMessage:"日报,周报，重大消息订阅",
        customizeMessage:"自定义指标消息订阅",
        support:"技术支持",
        annualPay:"年度付费用户",
        vipAnnualPay:"VIP年度付费用户",
        NewCurrency:"新币种及新技术指标优先使用",
        Withdrawal:"提现金额",
        none:"无",
        confirmSubmission:"确认提交",
        closeTransfer:"该笔交易已成功关闭！",
        upgradeSuccessful:"账户升级成功！",
        Withdrawal1:"提现",
        Recharge1:"充值",
        WithdrawalSuccess:"提现申请成功",
        withdrawalRecords:"提现记录",
        money:"金额",
        currency:"币种",
        network:"网络",
        applicationAddress:"申请地址",
        originatingAddress:"发起地址",
        refundAmount:"实退金额",
        refundAddress:"实退地址",
        refundTime:"退款完成时间",
        refundTxid:"实退交易hash",
        Remarks:"备注",
        pendingProcessing:"待处理订单",
        withdrawalRecords:"提现记录",
        successfulOrder:"成功订单",
        withdrawalFailed:"失败订单",
        placeholderAddress:"请输入邮箱查询",
        operation:"操作",
        confirm:"确定",
        refuse:"拒绝",
        cancel:"取消",
        prompt:"提示",
        rechargeAmount:"请确保输入金额格式正确,只能填写数字！",
        Txid:"交易hash",
        consumption:"消费记录",
        paymentCurrency:"请检查币种填写内容！",
        paymentNetwork:"请检查网络填写内容！",
        paymentAddress:"请检查地址填写内容！",
        paymentAmount:"请检查金额填写内容！",
        paymentCode:"请检查验证码填写内容！",
        AccountLevel_1:"当前账户等级",
        withdrawal_1:"申请提现",
        enterAmount:"请选择或输入",
        receivingAddress:"收款地址",
        input:"请输入",
        Reminder:"提示",
        Reminder_1:"1、提现需要通过人工审核，人工审核通常不会超过24小时。",
        Reminder_2:"2、提现时，每种稳定币会单独计算，请确保提现时您账户内相应的稳定币余额足够。",
        Reminder_3:"3、提现所产生的手续费需由您自己承担，该费用不同的区块网络会有所差异。",
        Reminder_4:"4、您最终收到的金额以实际到账为准。",
        Reminder_5:"1、您实际转账的网络和币种需与您提交的网络和币种一致，否则会导致您的转账无法在相应的区块链中被查询到。",
        Reminder_6:"2、本网站所有稳定币均视为等值，即为1USDT=1USDC=1BUSD，您的总余额为USDT余额+USDC余额+BUSD余额。",
        Reminder_7:"3、当单一稳定币余额不足以全额支付消费订单时，扣除顺序为USDT => USDC => BUSD，即优先扣除USDT，USDT余额不足以全额支付时，会继续扣除USDC，当USDT+USDC的余额不足以全额支付时，会继续扣除BUSD。",
        Reminder_8:"4、您充值的稳定币可在本网站用于升级服务、订阅咨询等任何付费服务。",
        Reminder_9:"5、转账后请妥善保管您的交易hash，交易hash是您转账的唯一凭证。",
        Reminder_10:"6、您在本网站的充值金额以我们实际收到的转账金额为准。",
        Reminder_11:"7、请不要未提交本页面内容就开始转账，该行为会导致我们无法对您的转账进行有效查询。",
        Reminder_12:"8、如有提前转账操作，请前往",
        Reminder_13:"交易hash页面",
        Reminder_14:"进行转账确认。",       
        accountBalance:"账户余额",
        toRecharge:"去充值?",
        toRecharge1:"去充值",
        Reminder_16:"1、本网站所有稳定币均视为等值，即为1USDT=1USDC=1BUSD，您的总余额为USDT余额+USDC余额+BUSD余额。", 
        Reminder_17:"2、当单一稳定币余额不足以全额支付消费订单时，扣除顺序为USDT => USDC => BUSD，即优先扣除USDT，USDT余额不足以全额支付时，会继续扣除USDC，当USDT+USDC的余额不足以全额支付时，会继续扣除BUSD。", 
        Reminder_18:"3、如果您的总余额不足以支付该笔消费，请前往充值页面进行充值。", 
        Reminder_19:"1、请您收到转账的交易hash之后再点击确认转账按钮，否则可能会因为网络延迟等原因导致我们无法在区块链上查询到您的转账。", 
        Reminder_20:"2、请您在30分钟内完成转账操作，如果未在30分钟完成转账，请回到", 
        Reminder_21:"充值页面", 
        Reminder_22:"重新提交订单。", 
        Reminder_23:"3、若因区块链网络原因导致充值未能及时到账，请您在获取到转账的交易hash后进入提交",
        Reminder_24:"提交您的交易hash，此时请确保您提交的交易hash能在相应的区块链网络上被查询到。",
        Reminder_25:"4、最终充值结果我们会以邮件形式通知您。",
        transactions:"验证交易hash",
        service:"联系客服",
        Address:"地址",
        waitFor:"等待确认",
        confirmTransfer:"确认已转账",
        closeTransfer:"关闭转账交易",
        problem:"转账遇到问题",
        rechargedSuccessfully:"充值成功！",
        orderNumber:"订单号",
        refundAmount:"退款金额",
        applicationTime:"申请时间",
        selectDate:"选择日期时间",
        Refusal:"拒绝提现",
        withdrawalDetails:"提现详情",
        currencyBalance:"当前币种余额",
        addAddress:"新增地址",
        fillInNew:"填写新增地址:",
        remind:"提示：每条新增地址须通过换行键单独放在一行",
        confirmAddition:"确认新增",
        confirmAddition2:"个收款地址",
        rechargeRecord:"充值记录",
        failedOrders:"支付失败订单",
        Reminder_26:"提示：该页面每4小时只能提交一次，所以请您仔细阅读下方文字",
        Reminder_27:"1、请仔细检查您填写的交易hash是否与区块链上的交易hash一致。",
        Reminder_28:"2、请仔细检查该交易hash的收款方是否为我们提供的钱包地址。",
        Reminder_29:"3、请仔细检查该交易hash的转账金额是否与您实际转账金额一致(手续费需由您自行支付)。",
        Reminder_30:"4、请勿恶意提交交易hash，否则可能会导致您的账号被封禁或其他处罚。如果您有多笔交易hash待处理，请您联系我们的",
        Reminder_31:"人工客服",
        queryWasSuccessful:"查询成功！",
        totalBalance:"当前总余额",
        expirationTime:"到期时间",
        consumptionInstructions:"消费说明",
        status:"状态",
        empty:"请确认新增地址数据填写正确！",
        mailbox:"验证码已发送您邮箱！",
        Insufficient:"余额不足！",
        userEmail:"用户邮箱",
        Disabled:"禁用",
        renew:"等级续费",
        userAddress:"绑定地址",
        appliedAddress:"提现地址",
        balance:"余额",
        refund:"实退金额",
        calculation:"计算中...",
        hashError:"交易hash有误,请仔细检查！",
        explain:"该时间为我们确认退款的时间，实际的退款时间以区块信息为准",
        grade:"请确认选择账户升级等级！",
        search:"请确认填写搜索内容！",
        transferSuccessful:"转账成功",
        transferFailed:"转账失败",
        Pending:"待处理",
        withdrawalSuccessful:"提现成功",
        withdrawalFailed1:"提现失败",
        hash1:"您还需",
        hash2:"时",
        hash3:"分",
        hash4:"秒后才能提交",
    }   
}
export const pay_en = {
    pay:{
        Payment:"Payment details",
        AccountUpgrade:"Account upgrade",
        AmountPaid:"Amount",
        currency:"Currency of payment",
        network:"Payment network",
        address:"Payment address",
        PaymentID:"Pay txid",
        SubmitPayment:"Submit payment",
        Confirmation:"Confirm payment information",
        AccountLevel:"Account level",
        ConfirmationPayment:"Confirmation of payment",
        cancel:"cancel",
        L2users:"Number of L2 users today",
        L3users:"Number of L3 users today",
        L4users:"Number of L4 users today",
        AmountReceived:"Amount received today",
        addL2:"The number of L2 users was added today",
        addL3:"The number of L3 users was added today",
        addL4:"The number of L4 users was added today",
        TotalCollection:"Total amount received",
        TotalCollectionL2:"L2 Total amount received by a user",
        TotalCollectionL3:"L3 Total amount received by a user",
        TotalCollectionL4:"L4 Total amount received by a user",
        chart:"Daily history chart",
        beConfirmedTable:"Payment list to be confirmed",
        confirmedTable:"Payment list confirmed",
        edit:"Editing history",
        number:"number",
        date:"date",
        user:"user",
        CausePayment:"Cause of payment",
        CollectionAddress:"Collection address",
        PaymentStatus:"Payment status",
        edit1:"edit",
        EditingReason:"Editing reason",
        submit:"submit",
        ServiceStatus:"Service status",
        OriginalPayment:"Original payment status",
        presentPaymentStatus:"Current payment status",
        EditUser:"Edit user",
        PaymentHistory:"Payment history",
        PurchaseService:"Purchase service",
        AccountAuthority:"Details about the account permission level",
        Refers:"index",
        WhetherPay:"Whether to pay",
        authority:"authority",
        granularity:"Data granularity",
        expense:"expense",
        AnonymousUser:"Anonymous user",
        technicalL1:"L1 technical index",
        technicalL2:"L2 technical index",
        technicalL3:"L3 technical index",
        technicalL4:"L4 technical index",
        RegisteredUser:"Registered user",
        monthlyPay:"Monthly payer",
        greatMessage:"Daily, weekly, major news subscriptions",
        customizeMessage:"Custom indicator message subscriptions",
        support:"Technical support",
        annualPay:"Annual payer",
        vipAnnualPay:"VIP Annual payer",
        NewCurrency:"New currency types and new technical indicators are preferred",
        Withdrawal:"Withdrawal amount",
        userPlan:"User Plan",
        none:"nothing",
        confirmSubmission:"Submit",
        closeTransfer:"This transaction has been successfully closed!",
        upgradeSuccessful:"Account upgrade successful!",
        Withdrawal1:"Withdrawal",
        Recharge1:"Recharge",
        withdrawalRecords:"withdrawal Records",
        money:"Money",
        currency:"Currency",
        network:"Network",
        applicationAddress:"Application address",
        originatingAddress:"Originating address",
        refundAmount:"Refund amount",
        refundTime:"Return time",
        refundTxid:"Return Transaction Hash",
        Remarks:"Remarks",
        pendingProcessing:"Pending orders",
        withdrawalRecords:"Withdrawal records",
        successfulOrder:"Successful order",
        withdrawalFailed:"Failed orders",
        placeholderAddress:"Please enter your email for query",
        operation:"Operation",
        confirm:"Confirm",
        refuse:"Refuse",
        cancel:"Cancel",
        prompt:"Prompt",
        rechargeAmount:"Please ensure that the input amount format is correct and only numbers can be filled in !",
        Txid:"Transaction Hash",
        consumption:"Consumption records",
        paymentCurrency:"Please check the currency filling content!",
        paymentNetwork:"Please check the network filling content!",
        paymentAddress:"Please check the address information!",
        paymentAmount:"Please check the amount filled in!",
        paymentCode:"Please check the content of the verification code!",
        AccountLevel_1:"Current account level",
        withdrawal_1:"Apply for withdrawal",
        enterAmount:"Please select or enter",
        receivingAddress:"Receiving address",
        input:"Please enter",
        Reminder:"Reminder",
        Reminder_1:"1、Withdrawal requires manual review, which usually does not exceed 24 hours。",
        Reminder_2:"2、When withdrawing, each type of stable currency will be calculated separately. Please ensure that the corresponding stable currency balance in your account is sufficient when withdrawing。",
        Reminder_3:"3、The handling fee generated by withdrawal must be borne by yourself, and this fee may vary depending on the blocknetwork。",
        Reminder_4:"4、The amount you ultimately receive will be based on the actual receipt。",
        Reminder_5:"1、The network and currency you actually transferred must be consistent with the network and currency you submitted, otherwise your transfer will not be able to be queried in the corresponding blockchain。",
        Reminder_6:"2、All stable currencies on this website are considered equivalent, i.e. 1USDT=1USDC=1BUSSD. Your total balance is USDT balance+USDC balance+BUSD balance。",
        Reminder_7:"3、When the balance of a single stable currency is insufficient to fully pay the consumption order, the deduction order is USDT=>USDC=>BUSD, which means that USDT will be deducted first. When the USDT balance is insufficient to fully pay, USDC will continue to be deducted. When the balance of USDT+USDC is insufficient to fully pay, BUSD will continue to be deducted。",
        Reminder_8:"4、The stable currency you recharge can be used on this website for any paid services such as upgrade services, subscription consulting, etc。",
        Reminder_9:"5、Please keep your transaction hash properly after the transfer. The transaction hash is the only voucher for your transfer。",
        Reminder_10:"6、The amount you recharge on this website is based on the actual transfer amount we receive。",
        Reminder_11:"7、Please do not start transferring funds without submitting the content on this page. This behavior may prevent us from effectively querying your transfer。",
        Reminder_12:"8、If there is an advance transfer operation, please go to",
        Reminder_13:"Transaction Hash page",
        Reminder_14:"Confirm transfer。",
        accountBalance:"Account balance",
        toRecharge:"recharge?",
        toRecharge1:"recharge",
        Reminder_16:"1、All stable currencies on this website are considered equivalent, i.e. 1USDT=1USDC=1BUSSD. Your total balance is USDT balance+USDC balance+BUSD balance。", 
        Reminder_17:"2、When the balance of a single stable currency is insufficient to fully pay the consumption order, the deduction order is USDT=>USDC=>BUSD, which means that USDT will be deducted first. When the USDT balance is insufficient to fully pay, USDC will continue to be deducted. When the balance of USDT+USDC is insufficient to fully pay, BUSD will continue to be deducted。", 
        Reminder_18:"3、If your total balance is not enough to pay for the purchase, please go to the recharge page to recharge。", 
        transactions:"validate Transaction Hash",
        service:"Contact customer service",
        Address:"Address",
        Reminder_19:"1、Please click the confirm transfer button after receiving the transaction hash of the transfer, otherwise we may not be able to query your transfer on the blockchain due to network delays and other reasons。", 
        Reminder_20:"2、Please complete the transfer operation within 30 minutes. If the transfer is not completed within 30 minutes, please return to", 
        Reminder_21:"Recharge page", 
        Reminder_22:"Resubmit Order。", 
        Reminder_23:"3、If the recharge is not received in a timely manner due to blockchain network reasons, please enter the submission after obtaining the transaction hash for the transfer",
        Reminder_24:"Submit your transaction hash, please ensure that the transaction hash you submitted can be queried on the corresponding blockchain network at this time。",
        Reminder_25:"4、We will notify you via email of the final recharge result。",
        waitFor:"Waiting for confirmation",
        confirmTransfer:"Confirm Transfer",
        closeTransfer:"Close transfer",
        problem:"Transfer problem",
        rechargedSuccessfully:"Recharged successfully!",
        orderNumber:"number",
        refundAmount:"refund amount",
        applicationTime:"Application time",
        selectDate:"Select Date Time",
        Refusal:"Refusal to withdraw",
        withdrawalDetails:"Withdrawal details",
        currencyBalance:"Current currency balance",
        addAddress:"Add Address",
        fillInNew:"Fill in the new address:",
        remind:"Reminder: Each newly added address must be placed on a separate line using the newline key",
        confirmAddition:"Confirm addition",
        confirmAddition2:"payment addresses",
        rechargeRecord:"Recharge Record",
        failedOrders:"Payment failed order",
        Reminder_26:"Reminder: This page can only be submitted once every 4 hours, so please read the text below carefully",
        Reminder_27:"1、Please carefully check if the transaction hash you filled in matches the transaction hash on the blockchain。",
        Reminder_28:"2、Please carefully check if the recipient of the transaction hash is the wallet address we provided。",
        Reminder_29:"3、Please carefully check whether the transfer amount of the transaction hash is consistent with your actual transfer amount (the handling fee needs to be paid by you)。",
        Reminder_30:"4、Please do not maliciously submit transaction hashes, as this may result in your account being banned or other penalties. If you have multiple transactions pending hash processing, please contact our",
        Reminder_31:"Manual customer service",
        queryWasSuccessful:"Query successful!",
        totalBalance:"Current total balance",
        expirationTime:"Expiration time",
         consumptionInstructions:"explain",
          status:"state",
          empty:"Please confirm that the new address data is filled in correctly!",
          mailbox:"The verification code has been sent to your email!",
          Insufficient:"Insufficient balance!",
          userEmail:"User email",
          Disabled:"Disabled",
          renew:"Level renewal",
          userAddress:"Bind Address",
        appliedAddress:"Withdrawal address",
        balance:"balance",
        refund:"Actual refund amount",
        calculation:"Calculating...",
        hashError:"Transaction hash error, please carefully check!",
        explain:"This is the time we confirm the refund, and the actual refund time is based on the block information",
        refundAddress:"refund Address",
        grade:"Please confirm selecting the account upgrade level!",
        search:"Please confirm to fill in the search content!",
        transferSuccessful:"Transfer successful",
        transferFailed:"Transfer failed",
        Pending:"Pending",
        withdrawalSuccessful:"Withdrawal successful",
        withdrawalFailed1:"Withdrawal failed",
        hash1:"You still need to",
        hash2:"Hour",
        hash3:"branch",
        hash4:"Seconds before submitting",


    }
}